import Vue from "vue";
import VueRouter from "vue-router";
import auth from "./auth";
import Home from "@/view/home/Home";
const User = () => import( /* webpackChunkName: "user" */ "@/view/user/user");
const Login = () => import( /* webpackChunkName: "login" */ "@/view/login/Login");
const Detail = () => import( /* webpackChunkName: "detail" */ "@/view/detail/detail");
const Search = () => import( /* webpackChunkName: "search" */ "@/view/search/search");
const Upload = () => import( /* webpackChunkName: "upload" */ "@/view/upload/upload");
const About = () => import( /* webpackChunkName: "about" */ "@/view/about/about");
const register = () => import( /* webpackChunkName: "register" */ "@/view/register/register");
const cloud = () => import( /* webpackChunkName: "cloud" */ "@/view/cloud/cloud");
const createCloud = () => import( /* webpackChunkName: "createCloud" */ "@/view/createCloud/createCloud");
const cloudList = () => import( /* webpackChunkName: "cloudList" */ "@/view/cloudList/cloudList");
const cloudListAdd = () => import( /* webpackChunkName: "cloudListAdd" */ "@/view/cloudListAdd/cloudListAdd");
const passwdReset = () => import( /* webpackChunkName: "cloudListAdd" */ "@/view/passwdReset/passwdReset");
Vue.use(VueRouter);

const routes = [{
    path: "*",
    redirect: "/"
  },
  {
    path: "/",
    component: Home
  },
  {
    path: "/user/center",
    component: User
  },
  {
    path: "/user/upload",
    component: Upload
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/detail/:id",
    component: Detail,
    props: true
  },
  {
    path: "/search",
    component: Search
  },
  {
    path: "/about",
    component: About
  },
  {
    path: "/register",
    component: register
  },
  {
    path: "/user/cloud",
    component: cloud
  },
  {
    path: "/user/cloud/create",
    component: createCloud
  },
  {
    path: "/cloud/:uuid",
    component: cloudList
  },
  {
    path: "/cloud/add/:uuid",
    component: cloudListAdd
  },
  {
    path: "/passwd_reset",
    component:passwdReset
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
//页面权限检查
router.beforeEach((to, from, next) => {
  let noPre = !auth.hasPremiss(to.path);
  noPre ? next(from.path) : next();
});
export default router;